import { FC } from 'react'
import LoginBackgroundImage from '../assets/image/LoginBackground.png'
import { BookDemo } from '../components/login/BookDemo'
import { LoginForm } from '../components/login/LoginForm'

export const Login: FC = () => {
  return (
    <div className="relative w-full h-[100dvh] overflow-hidden">
      <img
        className="absolute inset-0 w-full h-full object-cover z-0"
        src={LoginBackgroundImage}
        alt=""
      />
      <div className="absolute inset-0 flex flex-col justify-center items-center px-[5%] md:px-0">
        <LoginForm />
        <BookDemo />
      </div>
    </div>
  )
}
